import React from 'react';

export const useMemoizedArray = <T, R = T extends undefined ? undefined : Array<T>>(
  arr: Array<T> | undefined,
): R => {
  const ref = React.useRef(arr);
  React.useEffect(() => {
    if (!arr || !ref.current || arr.some((item, index) => item !== ref.current![index])) {
      ref.current = arr;
    }
  }, [arr]);
  return ref.current as R;
};
